import { useEffect, useState } from 'react';
import { useParams, usePathname } from 'next/navigation';

// Routes
import {
    ACCOUNT,
    DATA_ACCESS,
    PLATFORM_OPTIONS,
    SECURITY,
    SOCIAL_PROFILES,
    SUBSCRIPTION,
    THEMES,
    USERS_ROLES,
    SUBSCRIPTION_INVOICES,
    REFERRAL_PROGRAM,
    NOTIFICATIONS,
    INTEGRATIONS,
    GROUPS,
    REPORTS,
    REPORTS_ACCOUNTS,
    REPORTS_DASHBOARDS,
    REPORTS_COMPETITORS,
    REPORTS_HASHTAGS,
    INSPIRATION,
    SCHEDULER,
    REPORTS_EDIT
} from '@/lib/routes/privateRoutes';

// Utils
import { formatUrls } from '@/utils/urls/formatUrl';
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';

const URLS_WITHOUT_FIRST_STATS = [
    ACCOUNT,
    DATA_ACCESS,
    USERS_ROLES,
    SOCIAL_PROFILES,
    PLATFORM_OPTIONS,
    SECURITY,
    THEMES,
    SUBSCRIPTION,
    SUBSCRIPTION_INVOICES,
    REFERRAL_PROGRAM,
    NOTIFICATIONS,
    INTEGRATIONS,
    GROUPS,
    REPORTS,
    REPORTS_EDIT,
    REPORTS_ACCOUNTS,
    REPORTS_DASHBOARDS,
    REPORTS_COMPETITORS,
    REPORTS_HASHTAGS,
    INSPIRATION,
    SCHEDULER
];

const useDisplayFirstStatsPanel = () => {
    const { activeSocialProfile } = useActiveSocialProfile();
    const pathname = usePathname();
    const params = useParams();

    const firstStatsProfileAvailable =
        activeSocialProfile?.first_stats ||
        activeSocialProfile?.full_stats ||
        formatUrls(URLS_WITHOUT_FIRST_STATS, params).includes(pathname) ||
        !activeSocialProfile;

    const [hideFirstStatsEmptyState, setHideFirstStatsEmptyState] = useState(
        firstStatsProfileAvailable
    );

    useEffect(() => {
        if (firstStatsProfileAvailable !== hideFirstStatsEmptyState) {
            setHideFirstStatsEmptyState(firstStatsProfileAvailable);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [firstStatsProfileAvailable]);

    return {
        hideFirstStatsEmptyState,
        setHideFirstStatsEmptyState
    };
};

export default useDisplayFirstStatsPanel;
